export const type = {
  BOTH: 'both',
  STOPOVER: 'stopover',
  CRUISE: 'cruise',
};

export const texts = {
  1: {
    tips: [
      {
        heading: 'Tips!',
        text: 'Kom fram snabbt och smidigt till ditt hotell, förboka transfer för en ännu smidigare semester!',
        type: type.STOPOVER,
      },
      {
        heading: 'Du vet väl om...',
        text: 'att du inte behöver oroa dig för att få med all packning! Incheckat bagage ingår!',
        type: type.BOTH,
      },
      {
        heading: 'Du vet väl om...',
        text: 'att du skyddas av paketreselagen när du bokar din kombinationsresa hos oss!',
        type: type.BOTH,
      },
    ],
    loaderHeading:
      'Vi jobbar för fullt med att paketera din resa! Vi är snart klara',
    loaderHeadingShort: 'Ett steg närmre drömresan',
    loaderHeadingCabinList: 'Hämtar kryssningspaket',
  },
  3: {
    tips: [
      {
        heading: 'Tips!',
        text: 'Kom deg til hotellet på en rask og enkel måte. Forhåndsbestill transport for å få en enda mer behagelig ferie!',
        type: type.STOPOVER,
      },
      {
        heading: 'Du vet vel..',
        text: 'at du ikke trenger å bekymre deg for kostnaden for å få med deg alt du trenger. Innsjekket bagasje er inkludert!',
        type: type.BOTH,
      },
      {
        heading: 'Du vet vel..',
        text: 'at du er beskyttet av pakkereiseloven når du bestiller en kombinasjonsreise hos oss!',
        type: type.BOTH,
      },
    ],
    loaderHeading:
      'Vi jobber for fullt med å sette sammen reisen din! Vi er snart ferdige.',
    loaderHeadingShort: 'Ett steg nærmere drømmereisen',
    loaderHeadingCabinList: 'Henter cruisepakke',
  },
  11: {
    tips: [
      {
        heading: 'Tip!',
        text: 'Kom hurtigt og bekvemt frem til dit hotel – forudbestil transfer og få en endnu nemmere ferie!',
        type: type.STOPOVER,
      },
      {
        heading: 'Ved du godt ...',
        text: 'at du ikke skal bekymre dig om bagagen? Indjekket bagage indgår nemlig altid.',
        type: type.BOTH,
      },
      {
        heading: 'Ved du godt ...',
        text: 'at du er dækket af pakkerejseloven, når du bestiller en kombinationsrejse hos os?',
        type: type.BOTH,
      },
    ],
    loaderHeading:
      'Vi er i fuld gang med at pakke din rejse! Vi er snart klar.',
    loaderHeadingShort: 'Et skridt nærmere drømmerejsen',
    loaderHeadingCabinList: 'Finder krydstogtpakke',
  },
  15: {
    tips: [
      {
        heading: 'Vinkki!',
        text: 'Saavu hotelliisi helposti ja nopeasti. Varaa kuljetus etukäteen, niin lomasi alkaa sujuvammin!',
        type: type.STOPOVER,
      },
      {
        heading: 'Tiedäthän että, ...',
        text: ' sinun ei tarvitse varata matkatavaroita erikseen, sillä yksi ruumaan menevä matkatavara sisältyy hintaan!',
        type: type.BOTH,
      },
      {
        heading: 'Tiedäthän että, ...',
        text: 'kun varaat Tjäreborgin yhdistelmämatkan, sinua suojaa matkapakettilaki.',
        type: type.BOTH,
      },
    ],
    loaderHeading:
      'Matkaasi paketoidaan parhaillaan! Matkapakettisi on pian valmis.',
    loaderHeadingShort: 'Askeleen lähempänä unelmalomaa',
    loaderHeadingCabinList: 'Ladataan risteilypakettia',
  },
  18: {
    tips: [
      {
        heading: 'Tips!',
        text: 'Kom fram snabbt och smidigt till ditt hotell, förboka transfer för en ännu smidigare semester!',
        type: type.STOPOVER,
      },
      {
        heading: 'Du vet väl om...',
        text: 'att du inte behöver oroa dig för att få med all packning! Incheckat bagage ingår!',
        type: type.STOPOVER,
      },
      {
        heading: 'Du vet väl om...',
        text: 'att du skyddas av paketreselagen när du bokar din kombinationsresa hos oss!',
        type: type.STOPOVER,
      },
    ],
    loaderHeading: 'Tack för att du väntar medan vi skräddarsyr din resa...',
    loaderHeadingShort: 'Ett steg närmre drömresan',
    loaderHeadingCabinList: 'Hämtar kryssningspaket',
  },
};
